import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as LoginIcon } from "../../../images/loginicon.svg";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { FormLabel, TextField,Button } from "@material-ui/core";


function ViewCenter() {
  const classes = useStyles();
 
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [search, setSearch] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [center, setCenter] = useState([]);
  const navigate = useNavigate();

   const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

   const [page, setPage] = useState(0);
    
          const handlePageChange = (newPage) => {
        setPage(newPage);
        setOnPage(newPage) // Pass newSelection directly
      };
    
  const [rowCount, setRowCount] = useState("");

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleSearch = (query) => {
    setSearch(query);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editcenter") {
      navigate(`/admin/editcenter/${rowId}`);
    }
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const fetchData = async (pageNumber, size) => {
     if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center?page=${pageNumber + 1}&limit=${size}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setCenter(response.data.center);
      setRowCount(response.data.count);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    if (onPage !== undefined && pageSize !== undefined && search !== undefined) {
      fetchData(onPage, pageSize);
    }
  }, [onPage, pageSize, search]);

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      fetchData(onPage, pageSize , searchQuery);
      handleClose();
      toast.success("Branch deleted successfully");
      const updateddatatata = center.filter((data) => data.id !== rowId);
      setCenter(updateddatatata);
    } catch (error) {
      toast.error("Branch is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleCenterLogin = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/centers/auths/signin/user_access/${rowId}`,

        {},
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      handleClose();
      if (response.data.success === true) {
        const responseData = response.data;

        const token = responseData.token;
        const userName = response.data.user.center_name;

        const newTab = window.open(
          `${process.env.REACT_APP_Local_Pannel_Base_Path}/?token=${token}&userName=${userName}`,
          "_blank"
        );

        if (newTab) {
          setTimeout(() => {
            // Avoid passing the `navigate` function or any other circular references
            newTab.location.href = `${process.env.REACT_APP_Local_Pannel_Base_Path}/?token=${token}&userName=${userName}`;
          }, 1000);
        }
      }
    } catch (error) {
      toast.error("Client is Inactive so cannot login");
      console.error("Error in login: ", error);
    }
  };

  const handleStatus = (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    const data = {
      center: {
        active_status: newStatus,
        id: iddd,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/status`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      )
      .then((response) => {
        console.log("Branch status changed successfully", response);
        fetchData(onPage, pageSize , searchQuery);
        toast.success("Branch status changed successfully");
        handleClose();
      })
      .catch((error) => {
        console.error("Error changed Branch status:", error);
        toast.error("Branch status is not changed");
      });
  };
  const rows = center.map((d) => ({
    id: d.id ? d.id : "N/A",
    center_code: d.center_code ? d.center_code : "N/A",
    center_name: d.center_name ? d.center_name : "N/A",
    center_person_name: d.contact_person_name ? d.contact_person_name : "N/A",
    moble: d.phone ? d.phone : "N/A",
    city: d.city.name ? d.city.name : "N/A",
    active_status: d.active_status ? d.active_status : "N/A",
    center_user_id: d?.center_id ? d?.center_id : "N/A",
  }));
const startIndex = onPage * pageSize;

  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch = d.center_name
        .toLowerCase()
        .includes(search.toLowerCase());

      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: startIndex + index + 1,
    }));

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_code",
      headerName: "Branch Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_name",
      headerName: "Branch Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center", // Align the column header to center
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => (
        <div
          className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter}`}
          style={{ height: "100%" }}
        >
          {cellValues.value}
        </div>
      ),
    },
    {
      field: "center_person_name",
      headerName: "Branch Person Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "moble",
      headerName: "Moble No.",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "city",
      headerName: "City",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "active_status",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.active_status === "active";
        return (
          <div
            className={`${classes.dflex} ${classes.w100} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}

              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={() =>
                    handleCenterLogin(cellValues.row.center_user_id)
                  }
                >
                  <LightTooltip title="Login">
                    <LoginIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton
                  onClick={(event) => {
                    handleStatus(
                      cellValues.row.id,
                      cellValues.row.active_status
                    );
                  }}
                >
                  <LightTooltip title="Inactive">
                    <VisibilityOffOutlinedIcon />
                  </LightTooltip>
                </IconButton>

                <IconButton
                  onClick={() => {
                    handleButtonClick("editcenter", cellValues.row.id);
                  }}
                >
                  <LightTooltip title="Edit">
                    <EditOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => deleteDataOfRow(cellValues.row.id)}
                    />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      inputplaceholder: "Branch Name",
      inputlable: " ",
      import: "yes",
      export:"yes",
      exportFileName: "Branch.csv",
      exportApiUrl:`${process.env.REACT_APP_API_BASE_URL}/v1/client/center/branch/export/all`,
      importApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/branch/import`,
      fetchData: () => fetchData(onPage, pageSize),
    },
  ];

   const style = [
    {
      height:'maxh67',
      style: "viewtable",
          footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode:"server" 
    },
  ];
  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <TableViewSearch Heading={Heading} onSearch={handleSearch}/>


        
        {/* Manual search (commented out — now handled by TableViewSearch above)
        <div
          className={`${classes.dflex} ${classes.m0_5}`}
        >
          <div
            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
            >
              Search
            </FormLabel>
            <TextField
              type="text"
              variant="outlined"
              required
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Branch Name"
            />
          </div>
          <div
            className={`${classes.dflex} ${classes.flexdirectioncolumn}`}
          >
            <Button
              className={`${classes.custombtnblue} ${classes.mt1_5} ${classes.ml0_5}`}
              onClick={()=>fetchData(onPage, pageSize)}
            >
              search
            </Button>
          </div>
          <div
            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
          ></div>
        </div>
        */}
        <TableView columns={columns} rows={filteredRows} Heading={style} />
      </div>
    </>
  );
}
export default ViewCenter;
